import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useNotification } from './useNotification';

type UseHandleTrpcQueryProps = {
  error: {
    data?: { cause?: string } | null;
    message: string;
  } | null;
  errorRedirect?: string;
};

export const useHandleTrpcQuery = ({
  error,
  errorRedirect,
}: UseHandleTrpcQueryProps) => {
  const history = useHistory();
  const notification = useNotification();

  useEffect(() => {
    if (error) {
      notification.error(error?.data?.cause ?? error?.message);
      if (errorRedirect) {
        history.push(errorRedirect);
      }
    }
  }, [error]);
};
